<template>
<div class="page-form">

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />

    <img class="logo" :src="getLogo()" />
    <h2 class="title">{{ texts.professional }}</h2>

    <span v-if="config.login === 'ad'" class="ad-mode" type="is-info">
        {{ texts.activeDirectoryMode }} <b>{{ texts.on }}</b>
    </span>

    <b-field>
        <b-input
            v-model="user"
            :placeholder="texts.username"
            size="is-medium"
        />
    </b-field>
    <b-field>
        <b-input
            v-model="pwd"
            :placeholder="texts.password"
            type="password"
            size="is-medium"
        />
    </b-field>
    <div v-show="config.login !== 'ad'" class="pwd-forgot">
        <a
            type="is-dark"
            @click="forgotPassword()"
        >
            {{ texts.forgotPassword }}
        </a>
    </div>
    <a
        class="button is-success is-fullwidth btn-action"
        @click="login()"
    >
        {{ texts.connect }}
    </a>

</div>
</template>

<script>
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

export default {
    name: 'Login',
    mixins: [ Utils ],
    data () {
        return {
            isLoading: false,
            config: {},
            texts: {},
            user: null,
            pwd: null
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        if (HealthCareService.isLogged()) window.location.pathname = '/professional/call';
    },
    methods: {
        login() {
            if (!this.user || !this.pwd) return;
            this.isLoading = true;
            HealthCareService.login({ username: this.user, password: this.pwd })
                .then(response => {
                    if (response && response.data && response.data.token) {
                        const token = response.data.token;
                        localStorage.setItem('token', token);
                        localStorage.setItem('user', this.user);
                        window.location.pathname = '/professional/call';
                    }
                    this.isLoading = false;
                })
                .catch(error => {
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                    this.isLoading = false;
                });
        },
        forgotPassword() {
            this.$router.push('/recovery');
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pwd-forgot {
    text-align: left;
    margin-top: -5px;
    a {
        cursor: pointer;
        color: #2c3e50;
        font-size: 1em;
        font-weight: 700;
    }
}
.page-form {
    width: 500px;
    max-width: 90%;
    margin: 0 auto;
    overflow-y: auto;
}
.logo {
    max-width: 95%;
    max-height: 180px;
    @media (max-height: 450px) {
        display: none;
    }
}
.title {
    margin-top: 25px;
}
.btn-action {
    height: 60px;
    font-size: 1.3em;
    bottom: 20px;
    width: auto;
    margin-top: 30px;
    width: 100%;
}
.ad-mode {
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/professional/Login.vue